define('edap-tagmanager-integration',['edap','domhelpers'], function(edap, domHelpers) {
    'use strict';

    var moduleName = 'tagmanager',
        myEdap = new edap.Scope(moduleName);

    myEdap.on('tagmanager.load', function() {
        if (typeof domHelpers.getWindow().Bootstrapper === 'object') {
            return;
        }

        domHelpers.loadScript('//nexus.ensighten.com/homeaway/Bootstrap.js');
    });

    // NOTES
    // When we bring in Ensigthen 2.0 we'll need to do a few things:
    // 1. Add an on('*') handler that will need to extend all the event data
    //    into myEdap.getScopeData().eventData. Then it needs to fire a 
    //    Ensighten 2.0 event, if it is loaded. Otherwise queue and wait for
    //    Ensighten Bootstrap to load then flush.
    // 2. In Ensighten 2.0 we map our data layer vars as "always evaluate" and
    //    looking at the edap.internal.scopes.tagmanager.data


    return edap;
});

